import type {SessionWithToken} from '@blaxel/core';
import {z} from 'zod/v4';
import {expectType, TypeEqual} from '@packages/utilities/type-safety';

/**
 * Zod schema for a sandbox session
 */
export const SandboxSession = z.object({
  name: z.string().describe('The name of the session'),
  url: z.string().describe('The URL of the session'),
  token: z.string().describe('The token of the session'),
  expiresAt: z
    .union([z.date(), z.iso.date(), z.iso.datetime()])
    .transform((value) => (value instanceof Date ? value : new Date(value)))
    .describe('The expiration time of the session'),
});
export type SandboxSession = z.infer<typeof SandboxSession>;
expectType<TypeEqual<SandboxSession, SessionWithToken>>(true);

/**
 * Zod schema for sandbox creation response
 */
export const CreateSandboxResponse = z.object({
  sandboxId: z.string().describe('The unique identifier of the sandbox'),
  session: SandboxSession.describe('The browser session for the sandbox'),
});
export type CreateSandboxResponse = z.infer<typeof CreateSandboxResponse>;

/**
 * Zod schema for delete sandbox response
 */
export const DeleteSandboxResponse = z.void();
export type DeleteSandboxResponse = z.infer<typeof DeleteSandboxResponse>;
